// extracted by mini-css-extract-plugin
export default {"CardButtons":"ChargingTokenDesignCardSkeleton_CardButtons__HlmGE","CardIcons":"ChargingTokenDesignCardSkeleton_CardIcons__Gmtan"};